import type { CardDashboardState } from './CardDashboard.types'

export const CARD_DASHBOARD_CONFIG = {
  dimensions: {
    small: {
      height: {
        expanded: 'unset',
        collapsed: 'unset'
      }
    },
    large: {
      height: {
        expanded: '500px',
        collapsed: '155px'
      }
    }
  }
} as const

export const getDashboardConfig = (
  props: Partial<Pick<CardDashboardState, 'isExpanded' | 'isSmall'>>
) => {
  const size = props.isSmall ? 'small' : 'large'
  const height = props.isExpanded ? 'expanded' : 'collapsed'

  return {
    height: CARD_DASHBOARD_CONFIG.dimensions[size].height[height]
  }
}
